import { Stack } from "@mui/material";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { EntradaForm, H6 } from "../../../../components";
import { useToggle } from "react-use";
import { usersPageGlobalVariableAddEdit } from "../reducers/users-page-global-variable-actions";
import { obterValidador, VALIDADOR_TIPO } from "../../../../utils";

const STR = {
  titleAdd: "Adicionar variável global",
  titleEdit: "Editar variável global",
  labelName: "Nome",
  labelValue: "Valor",
  labelDescription: "Descrição",
  placeholderName: "Digite o nome",
  placeholderValue: "Digite o valor",
  placeholderDescription: "Digite a descrição",
  errorName: "* O nome deve conter ao menos 3 caracteres",
  errorValue: "* O valor é obrigatório",
  errorDescription: "* A descrição deve conter ao menos 3 caracteres",
};

const KEYS = {
  name: "nome",
  value: "valor",
  description: "descricao",
};

function GlobalVariableAddEdit({ id, name, value, description }) {
  const [wait, setWait] = useToggle();

  const dispatch = useDispatch();

  const schemaMessageError = {
    [KEYS.name]: STR.errorName,
    [KEYS.value]: STR.errorValue,
    [KEYS.description]: STR.errorDescription,
  };
  const schemaValidator = yup.object().shape({
    [KEYS.name]: obterValidador(VALIDADOR_TIPO.texto, 3),
    [KEYS.value]: obterValidador(VALIDADOR_TIPO.texto, 1),
    [KEYS.description]: obterValidador(VALIDADOR_TIPO.texto, 3),
  });
  //
  const schema = [
    {
      type: "text",
      name: KEYS.name,
      label: STR.labelName,
      placeholder: STR.placeholderName,
      defaultValue: name,
      disabled: id ? true : false,
    },
    {
      type: "textarea",
      minRows: 3,
      multiline: true,
      name: KEYS.description,
      label: STR.labelDescription,
      placeholder: STR.placeholderDescription,
      defaultValue: description,
    },
    {
      type: "text",
      name: KEYS.value,
      label: STR.labelValue,
      placeholder: STR.placeholderValue,
      defaultValue: value,
    },
  ];
  //
  const onSubmit = useCallback(
    (val) => {
      const obj = {
        [KEYS.name]: val[KEYS.name],
        [KEYS.value]: val[KEYS.value],
        [KEYS.description]: val[KEYS.description],
      };
      if (id) {
        obj.id = id;
        delete obj[KEYS.name];
      }

      dispatch(usersPageGlobalVariableAddEdit(obj, setWait));
    },
    [dispatch, id, setWait]
  );
  //
  return (
    <Stack>
      <H6>{id ? STR.titleEdit : STR.titleAdd}</H6>
      <EntradaForm
        schema={schema}
        schemaValidator={schemaValidator}
        schemaMessageError={schemaMessageError}
        onSubmit={onSubmit}
        wait={wait}
      />
    </Stack>
  );
}

export default GlobalVariableAddEdit;
